import lightSlider from "../assets/vendor/lightSlider_1_1_5";

export default window.lightSlider = lightSlider;
